import { boolean, object, string } from 'yup';
import { PEP_FIELD } from '@app/configs/solvencyDeclaration';
export const generateYupSchema = (questionnaire) => {
    const shape = Object.values(questionnaire).reduce((acc, field) => {
        let validator = string().trim();
        if (field.type === 'checkbox') {
            validator = boolean();
            if (field.req) {
                validator = validator.oneOf([true]);
            }
        }
        if (field.reqif) {
            const [dependentField, value] = field.reqif.split('=');
            let checkValue = value;
            if (questionnaire[dependentField].type === 'checkbox') {
                checkValue = true;
            }
            validator = validator.when(dependentField, {
                is: checkValue,
                then: (schema) => schema.required(`${field.label} is required`),
                otherwise: (schema) => schema.notRequired(),
            });
        }
        if (field.req) {
            validator = validator.required(`${field.label} is required`);
        }
        if (field.name === PEP_FIELD) {
            validator = validator.oneOf(['no']);
        }
        acc[field.name] = validator;
        return acc;
    }, {});
    return object().shape(shape);
};
